import { render, staticRenderFns } from "./SchedulesKanban.vue?vue&type=template&id=16d79988&"
import script from "./SchedulesKanban.vue?vue&type=script&lang=js&"
export * from "./SchedulesKanban.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports